import { useNavigate, useSearchParams } from "react-router-dom";
import { BankConnectionReturn } from "@/components/BankConnectionReturn";
import { PageContainer, PageHeader } from "@/components/PagePrimitives";

export function BankConnectionReturnPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  return (
    <PageContainer size="narrow">
      <PageHeader eyebrow="Organisation" title="Bank connection" />
      <BankConnectionReturn
        bankConnectionId={searchParams.get("bankConnectionId")}
        status={searchParams.get("status")}
        onDone={() => navigate("/organisation/bank-connections", { replace: true })}
      />
    </PageContainer>
  );
}
